"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const constant_1 = require("../constants/constant");
function getTenant() {
    const hostName = window.location.hostname;
    const tenantArray = hostName.split(".").slice(-1);
    if (tenantArray.length === 0) {
        return "ID";
    }
    const tenant = tenantArray[0].toUpperCase();
    if (constant_1.ARRAY_TENANT.indexOf(tenant) === -1) {
        return "ID";
    }
    return tenant;
}
exports.default = getTenant;
//# sourceMappingURL=getTenant.js.map